module.exports = "/_next/static/images/fruit_sand-d92b6d5a0d5d1b788f7c7258f052a7df.jpg";